import { SubmitErrorHandler, SubmitHandler } from "react-hook-form";

import { useCaptchaHandlers } from "./useCaptchaHandlers";

import { RegisterProps } from "../types/register";

import { alertActions } from "../../../../features/alert/alertSlice";
import { registerUser, verifyEmail } from "../../../../lib/api";
import { IRegisterUserData } from "../../../../types/forms";

export const useFormHandlers = (props: RegisterProps) => {
    const { methods, dispatch } = props;
    const { setError } = methods;
    const { verifyCaptcha } = useCaptchaHandlers(props);

    const onSubmit: SubmitHandler<IRegisterUserData> = async data => {
        try {
            await verifyEmail(data.email);
        } catch (e) {
            setError(
                "email",
                {
                    type: "custom",
                    message: "The specified email is already registered",
                },
                {
                    shouldFocus: true,
                },
            );
            return false;
        }

        if (verifyCaptcha()) {
            await registerUser(data, "umpire")
                .then(() => {
                    dispatch(
                        alertActions.success({
                            title: "Registration Successful",
                            text: "Thank you for registering",
                        }),
                    );
                })
                .catch(e => {
                    dispatch(
                        alertActions.error({
                            title: `The server encountered a problem registering your account.`,
                            text: "If the problem continues, please reach out to an admin.",
                            dismissible: true,
                        }),
                    );
                });
        }
    };

    const onError: SubmitErrorHandler<IRegisterUserData> = (data): void => {
        verifyCaptcha();
    };

    return { onSubmit, onError };
};
